import React from 'react';
import { RootStore } from '../stores/RootStore';

export const store = new RootStore();
export const StoreContext = React.createContext(store);

export const useStores = () => React.useContext(StoreContext);
